




import { Component, Mixins, Prop } from "vue-property-decorator";
import { IKeyHandleable } from "./IKeyHandleable";

@Component
export default class RedoKeyHandler extends Mixins() implements IKeyHandleable {
  @Prop()
  redone: () => boolean;

  handleKeyDowned(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    if (!event.ctrlKey || (event.key !== "y")) {
      return false;
    }
    if (isInputting) {
      return false;
    }
    return !!this.redone
        && this.redone();
  }

  handleKeyUpped(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    return false;
  }
}
